module.exports = __webpack_public_path__ + "static/media/master-card-logo.23f7f333.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/master-card-logo.svg
 ** module id = 1280
 ** module chunks = 0
 **/